import featureClient9 from "../clients/boholsocialclub/feature.json";
import featureClient1 from "../clients/buko/feature.json";
import featureClient6 from "../clients/hff/feature.json";
import featureClient7 from "../clients/leonidascafe/feature.json";
import featureClient8 from "../clients/mcscarwash/feature.json";
import featureClient4 from "../clients/petrobest/feature.json";
import featureClient3 from "../clients/pushndrip/feature.json";
import featureClient2 from "../clients/tamper/feature.json";
import featureClient5 from "../clients/vapexlounge/feature.json";
import { appConfig } from "./app.config";

export const appFeatureRecord = {
  ["buko"]: featureClient1,
  ["tamper"]: featureClient2,
  ["pushndrip"]: featureClient3,
  ["petrobest"]: featureClient4,
  ["vapexlounge"]: featureClient5,
  ["hff"]: featureClient6,
  ["leonidascafe"]: featureClient7,
  ["mcscarwash"]: featureClient8,
  ["boholsocialclub"]: featureClient9
};
export const appFeature =
  appFeatureRecord[appConfig.client as keyof typeof appFeatureRecord];
export const ageConsent = 18;
